import { NgStyle } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FieldWrapper } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-formly-wrapper-mat-addons',
  templateUrl: './formly-wrapper-mat-addons.component.html',
  styleUrls: ['./formly-wrapper-mat-addons.component.scss'],
  imports: [
    NgStyle,
    MatIcon,
    MatTooltip,
    TranslateModule,
    MatPrefix,
    MatSuffix,
  ],
})
export class FormlyWrapperMatAddonsComponent
  extends FieldWrapper
  implements AfterViewInit, OnInit
{
  constructor(private translate: TranslateService) {
    super();
  }

  addonRightVisible = false;
  addonLeftVisible = false;

  ngOnInit(): void {
    if (this.props.addonRight && this.props.addonRight.tooltip) {
      this.translate.get(this.props.addonRight.tooltip).subscribe(s => {
        this.addonRightVisible = this.props.addonRight.tooltip != s;
      });
    } else {
      this.addonRightVisible = true;
    }

    if (this.props.addonLeft && this.props.addonLeft.tooltip) {
      this.translate.get(this.props.addonLeft.tooltip).subscribe(s => {
        this.addonLeftVisible = this.props.addonLeft.tooltip != s;
      });
    } else {
      this.addonLeftVisible = true;
    }
  }

  @ViewChild('matPrefix')
  matPrefix!: TemplateRef<any>;

  @ViewChild('matSuffix')
  matSuffix!: TemplateRef<any>;

  ngAfterViewInit() {
    if (this.matPrefix) {
      Promise.resolve().then(() => (this.props.prefix = this.matPrefix));
    }

    if (this.matSuffix) {
      Promise.resolve().then(() => (this.props.suffix = this.matSuffix));
    }
  }

  addonRightClick($event: any) {
    if (this.props.addonRight && this.props.addonRight.onClick) {
      this.props.addonRight.onClick(this.props, this, $event);
    }
  }

  addonLeftClick($event: any) {
    if (this.props.addonLeft && this.props.addonLeft.onClick) {
      this.props.addonLeft.onClick(this.props, this, $event);
    }
  }
}
